import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { formatDateReadable } from "../../utilities/helpers";
import { Drawer } from "@mui/material";
import DrawerHeader from "../../shared/helpers/DrawerHeader";
import ButtonFilled from "../../shared/helpers/ButtonFilled";
import DrawerFooterContainerSmall from "../../shared/helpers/DrawerFooterContainerSmall";
import { getCardColor2 } from "../../../../../helpers/helpers";
import StatusWithText from "../../shared/helpers/StatusWithText";
import { get_t_str } from "../../../../../helpers/helpers";

export default function TradesApprovedTableRow(props) {
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const isApproved = props.trade?.type === "trade_accepted";

  function handleArchive() {
    props.archive_trade_request(props.trade.uuid);
    setDrawerOpen(false);
  }


  return (
    <>
      <tr
        className="hover:bg-slate-50 cursor-pointer transition-colors"
        onClick={toggleDrawer(true)}
      >
        <td className="py-3.5 pl-6 pr-3 text-sm">
          <div className="flex items-center rounded-xl bg-slate-50 border border-slate-100 px-3 py-3">
            <div className="flex-1">
              <p className="text-sm font-semibold text-slate-900">
                {props.trade?.employee_drop?.first_name} {props.trade?.employee_drop?.last_name}
              </p>
              <p className="text-xs text-slate-400 mt-0.5">is trading away</p>
              <div className="flex mt-2">
                <div className={`w-1 rounded-full mr-2 ${getCardColor2(props.trade?.shift_drop_json?.role_id?.id, props.roleNames, false)}`}></div>
                <div>
                  <p className="text-xs font-semibold text-slate-900">{get_t_str(props.trade?.shift_drop_json?.shift_start)} - {get_t_str(props.trade?.shift_drop_json?.shift_end)}</p>
                  <p className="text-xs text-slate-500 mt-0.5">
                    {props.trade?.shift_drop_json?.station ? props.trade?.shift_drop_json?.station?.name :
                     props.trade?.shift_drop_json?.role_id?.role_name ? props.trade?.shift_drop_json?.role_id?.role_name :
                     props.trade?.shift_drop_json?.role_id?.role_type}
                  </p>
                  <p className="text-xs text-slate-400 mt-0.5">{formatDateReadable(props.trade?.shift_drop_json?.date)}</p>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td className="px-3 py-3.5 text-sm">
          <div className="w-full flex justify-center">
            <div className={`w-8 h-8 flex items-center justify-center rounded-full ${
              isApproved ? "bg-green-50 border border-green-200" : "bg-red-50 border border-red-200"
            }`}>
              {isApproved ? (
                <CheckIcon sx={{ fontSize: 14, color: "#16a34a" }} />
              ) : (
                <CloseIcon sx={{ fontSize: 14, color: "#dc2626" }} />
              )}
            </div>
          </div>
        </td>
        <td className="pr-6 py-3.5 text-sm">
          <div className="flex items-center rounded-xl bg-slate-50 border border-slate-100 px-3 py-3">
            <div className="flex-1">
              <p className="text-sm font-semibold text-slate-900 text-right">
                {props.trade?.employee_pickup?.first_name} {props.trade?.employee_pickup?.last_name}
              </p>
              <p className="text-xs text-slate-400 mt-0.5 text-right">is trading away</p>
              <div className="flex flex-row-reverse mt-2">
                <div className={`w-1 rounded-full ml-2 ${getCardColor2(props.trade?.shift_pickup_json?.role_id?.id, props.roleNames, false)}`}></div>
                <div>
                  <p className="text-xs font-semibold text-slate-900 text-right">{get_t_str(props.trade?.shift_pickup_json?.shift_start)} - {get_t_str(props.trade?.shift_pickup_json?.shift_end)}</p>
                  <p className="text-xs text-slate-500 mt-0.5 text-right">
                    {props.trade?.shift_pickup_json?.station ? props.trade?.shift_pickup_json?.station?.name :
                     props.trade?.shift_pickup_json?.role_id?.role_name ? props.trade?.shift_pickup_json?.role_id?.role_name :
                     props.trade?.shift_pickup_json?.role_id?.role_type}
                  </p>
                  <p className="text-xs text-slate-400 mt-0.5 text-right">{formatDateReadable(props.trade?.shift_pickup_json?.date)}</p>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td className="relative py-3.5 pl-3 pr-6">
        </td>
      </tr>
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <div className="w-[450px] h-full bg-white relative">
          <div className="max-h-screen overflow-auto">
            <DrawerHeader title="Trade Details" onClose={toggleDrawer(false)} />
            <div className="px-6 mt-6">
              <div className="w-full flex flex-row items-stretch relative">
                <div className="w-1/2 pr-3">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Sender</p>
                  <div className="rounded-xl bg-slate-50 border border-slate-100 px-3 py-3">
                    <p className="text-sm font-semibold text-slate-900">
                      {props.trade?.employee_drop?.first_name} {props.trade?.employee_drop?.last_name}
                    </p>
                    <p className="text-xs text-slate-400 mt-0.5">is trading away</p>
                    <div className="flex mt-2">
                      <div className={`w-1 rounded-full mr-2 ${getCardColor2(props.trade?.shift_drop_json?.role_id?.id, props.roleNames, false)}`}></div>
                      <div>
                        <p className="text-xs font-semibold text-slate-900">{get_t_str(props.trade?.shift_drop_json?.shift_start)} - {get_t_str(props.trade?.shift_drop_json?.shift_end)}</p>
                        <p className="text-xs text-slate-500 mt-0.5">
                          {props.trade?.shift_drop_json?.station
                            ? props.trade?.shift_drop_json?.station?.name
                            : props.trade?.shift_drop_json?.role_id?.role_name
                            ? props.trade?.shift_drop_json?.role_id?.role_name
                            : props.trade?.shift_drop_json?.role_id?.role_type}
                        </p>
                        <p className="text-xs text-slate-400 mt-0.5">{formatDateReadable(props.trade?.shift_drop_json?.date)}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute z-30 left-1/2 top-1/2 -ml-4 mt-1">
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full ${
                    isApproved ? "bg-green-50 border border-green-200" : "bg-red-50 border border-red-200"
                  }`}>
                    {isApproved ? (
                      <CheckIcon sx={{ fontSize: 14, color: "#16a34a" }} />
                    ) : (
                      <CloseIcon sx={{ fontSize: 14, color: "#dc2626" }} />
                    )}
                  </div>
                </div>
                <div className="w-1/2 pl-3">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2 text-right">Receiver</p>
                  <div className="rounded-xl bg-slate-50 border border-slate-100 px-3 py-3">
                    <p className="text-sm font-semibold text-slate-900 text-right">
                      {props.trade?.employee_pickup?.first_name} {props.trade?.employee_pickup?.last_name}
                    </p>
                    <p className="text-xs text-slate-400 mt-0.5 text-right">is trading away</p>
                    <div className="flex flex-row-reverse mt-2">
                      <div className={`w-1 rounded-full ml-2 ${getCardColor2(props.trade?.shift_pickup_json?.role_id?.id, props.roleNames, false)}`}></div>
                      <div>
                        <p className="text-xs font-semibold text-slate-900 text-right">{get_t_str(props.trade?.shift_pickup_json?.shift_start)} - {get_t_str(props.trade?.shift_pickup_json?.shift_end)}</p>
                        <p className="text-xs text-slate-500 mt-0.5 text-right">
                          {props.trade?.shift_pickup_json?.station
                            ? props.trade?.shift_pickup_json?.station?.name
                            : props.trade?.shift_pickup_json?.role_id?.role_name
                            ? props.trade?.shift_pickup_json?.role_id?.role_name
                            : props.trade?.shift_pickup_json?.role_id?.role_type}
                        </p>
                        <p className="text-xs text-slate-400 mt-0.5 text-right">{formatDateReadable(props.trade?.shift_pickup_json?.date)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-6">
                <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Status</p>
                <StatusWithText status={isApproved ? "approved" : "denied"} />
              </div>

              {props.trade?.acting_manager_name && (
                <div className="mt-6">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Responded By</p>
                  <p className="text-sm font-semibold text-slate-900">{props.trade.acting_manager_name}</p>
                </div>
              )}
            </div>
            <div className="h-[200px]"></div>
            <DrawerFooterContainerSmall>
              <div className="w-full">
                <ButtonFilled text="Close" onClick={toggleDrawer(false)} />
              </div>
            </DrawerFooterContainerSmall>
          </div>
        </div>
      </Drawer>
    </>
  );
}
